import * as actions from '../../utils/Actions';
import { undefinedOrZero,notUndefinedAndNull  } from '../../utils/Validation'

const initialState = {
    showPageLoader: false,
    allBranches: [],
    academicYears: [],
    currentAcademicYear: null,
    banners: [],
    branch: null,
    branchLogo:null,
    captchaValue:null,
    bankBranding:null

}

export default function branch(state = initialState, action) {

    if (typeof state === 'undefined') {
        return state;
    }

    switch (action.type) {
        

        case actions.RESET_BRANCH_DATA:
            return {
                ...state,
                allBranches: [],
                academicYears: [],
                currentAcademicYear: null,
                banners: [],
                branch: null,
                branchLogo:null,
            }
        case actions.pending(actions.GET_ALL_BRANCHES_BY_INSTITUTE_ID):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_ALL_BRANCHES_BY_INSTITUTE_ID):
            return {
                ...state,
                showPageLoader: false,
                allBranches: action.payload.data
            }

        case actions.rejected(actions.GET_ALL_BRANCHES_BY_INSTITUTE_ID):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.GET_BANNERS_BY_INSTITUTE_ID_AND_BRANCH_ID):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_BANNERS_BY_INSTITUTE_ID_AND_BRANCH_ID):
            return {
                ...state,
                showPageLoader: false,
                banners: action.payload.data
            }

        case actions.rejected(actions.GET_BANNERS_BY_INSTITUTE_ID_AND_BRANCH_ID):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.LIST_ACADEMIC_YEARS_BY_BRANCH_ID):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.LIST_ACADEMIC_YEARS_BY_BRANCH_ID):

            let ayList = action.payload.data;
            let currentAY = null;

            if (!undefinedOrZero(ayList)) {
                for (let i = 0; i < ayList.length; i++) {
                    let ay = ayList[i];
                    if (ay.isCurrentActiveYear === 'Y') {
                        currentAY = ay;
                        break;
                    }
                }
            }

            return {
                ...state,
                academicYears: ayList,
                currentAcademicYear: currentAY,
                showPageLoader: false
            }

        case actions.rejected(actions.LIST_ACADEMIC_YEARS_BY_BRANCH_ID):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.GET_BRANCH):
            return {
                ...state
            }

        case actions.fulfilled(actions.GET_BRANCH):
            return {
                ...state,
                branch: action.payload.data
            }

        case actions.rejected(actions.GET_BRANCH):
            return {
                ...state
            }

        case actions.pending(actions.GET_BRANCH_LOGO):
            return {
                ...state
            }

        case actions.fulfilled(actions.GET_BRANCH_LOGO):
            let url = null;
            if(typeof action.payload.data === "string"){
                url = action.payload.data
            }
            return {
                    ...state,
                    branchLogo: url
                }

        case actions.rejected(actions.GET_BRANCH_LOGO):
            return {
                ...state
            }

        case actions.pending(actions.GET_BANK_BRANDING):
            return {
                ...state
            }

        case actions.fulfilled(actions.GET_BANK_BRANDING):

            return {
                    ...state,
                    bankBranding: action.payload.data
                }

        case actions.rejected(actions.GET_BANK_BRANDING):
            return {
                ...state
            }   
            
        case actions.pending(actions.GET_CAPTACHA_VALUE):
            return {
                ...state
            }

        case actions.fulfilled(actions.GET_CAPTACHA_VALUE):

            return {
                    ...state,
                    captchaValue: action.payload.data
                }

        case actions.rejected(actions.GET_CAPTACHA_VALUE):
            return {
                ...state
            }    
        
    
            
        default:
            return { ...state }
    }
}